import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {withTranslation} from 'react-i18next';
import footer_logo from '../../assets/img/footer_logo.png';

const ShortFooter = ({ additionalClass, t, branchInfo }) => {
  return (
    <>
      {branchInfo.use_pin_pad_flg === 0 && (
        <footer id="short-footer" className={ `short-footer ${additionalClass}` }>
          <div className="container container-inner">
            <div className="row">
              <div className="col-md-12 ipos-copyright">
                powered by
                { branchInfo.use_pin_pad_flg === 1 && (
                  <b> iPOS</b>
                ) }

                { (branchInfo.use_pin_pad_flg === 0 || !branchInfo.use_pin_pad_flg) && (
                  <a href={ 'http://www.ipos.co.il' } target={ 'blank' }> iPOS</a>
                ) }

              </div>
            </div>
          </div>
        </footer>)        
      }
      {branchInfo.use_pin_pad_flg === 1 && (
        <footer id="long-footer" className={ `long-footer ${additionalClass}` }>           
          <div className="ipos-copyright">
          </div>         
        </footer>)
      }
    </>
  );
};

const mapStateToProps = (state) => {
  const {
    branchInfo
  } = state;

  return {
    branchInfo
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
    },
    dispatch,
  );

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ShortFooter));
